<script>

    import { createEventDispatcher } from 'svelte'

    const dispatch = createEventDispatcher()

    export let label = null
    export let value = null
    export let placeholder = ''
    export let pattern = null
    export let maxlength = null

    export let required = true

    export let readonly = false

</script>

<div class="field">
    {#if label}
        <label for="" class="label">{ label }</label>
    {/if}
    <div class="control">
        <input bind:value={value} on:keyup on:keyup={e => e.code === 'Enter' && dispatch('enter')} class="input" type="password" 
            { pattern } { placeholder } { required } { maxlength } { readonly } >
    </div>
</div>
